import React from 'react';
import AdminHeader from 'components/organisms/Header';
import { PageContentStyled } from 'components/molecules/PageContent/styled';
import { StyledContentWrapper } from 'components/molecules/ContentWrapper/styled';

const SuperAdminLayoutShell = ({ children }) => {
  return (
    <PageContentStyled>
      <AdminHeader />
      <StyledContentWrapper>{children}</StyledContentWrapper>
    </PageContentStyled>
  );
};

export default SuperAdminLayoutShell;
